import React from 'react';
import { ArrowRight, Star, ShieldCheck, Mail } from 'lucide-react';
import { ChalkboardPattern } from './ChalkboardPattern';
export function FinalCTA() {
  return <section className="bg-pilates-blue-dark py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-t border-b border-pilates-lavender" data-id="element-79">
      <ChalkboardPattern className="text-white opacity-[0.04]" data-id="element-80" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-81">
        <div className="border border-pilates-lavender text-pilates-lavender font-semibold text-xs px-4 py-1.5 mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-82">
          LAST CHANCE
        </div>

        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-tight mb-5 tracking-tight" data-id="element-83">
          Your players deserve the best version of you, not an{' '}
          <span className="italic text-pilates-lavender" data-id="element-84">exhausted one</span>.
        </h2>

        <p className="text-white/85 text-lg mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-85">
          Stop spending your Sundays planning. Take control of your career with
          elite tools.
        </p>

        <div className="bg-white/5 backdrop-blur-sm border border-pilates-lavender rounded-lg p-6 mb-6 max-w-sm mx-auto" data-id="element-86">
          <p className="text-white/80 text-sm mb-2 font-medium" data-id="element-87">
            6-in-1 Bundle: VolleyReady + 5 Premium Bonuses
          </p>
          <p className="text-white/60 text-sm mb-1" data-id="element-88">
            <span className="line-through" data-id="element-89">$97 USD</span>
          </p>
          <p className="text-pilates-lavender text-sm mb-1 font-bold uppercase tracking-wider" data-id="element-90">
            Only:
          </p>
          <p className="font-display text-6xl sm:text-7xl font-semibold text-white leading-none" data-id="element-91">
            <span className="text-3xl sm:text-4xl text-pilates-lavender mr-1" data-id="element-92">
              $
            </span>
            27
            <span className="text-2xl sm:text-3xl text-pilates-lavender ml-1.5" data-id="element-93">
              USD
            </span>
          </p>
        </div>

        <a href="https://volley-ready.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white font-semibold text-base sm:text-lg py-4 px-8 sm:px-12 rounded-lg border-t border-white/20 shadow-[0_15px_40px_rgba(192,57,43,0.5)] hover:shadow-[0_20px_50px_rgba(192,57,43,0.7)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto" data-id="element-94">
          <span data-id="element-95">🏐 YES, I WANT MY VOLLEYREADY BUNDLE</span>
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-96" />
        </a>

        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-97">
          <div className="flex items-center gap-2 text-white/85 text-sm" data-id="element-98">
            <Mail className="w-4 h-4 text-pilates-lavender" data-id="element-99" />
            <span data-id="element-100">Immediate Access — Email Delivery</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-101">
            <div className="flex text-pilates-lavender" data-id="element-102">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-103" />)}
            </div>
            <span className="text-white/90 text-sm font-medium" data-id="element-104">
              4.9/5 — Verified Reviews
            </span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm" data-id="element-105">
            <ShieldCheck className="w-4 h-4 text-pilates-lavender" data-id="element-106" />
            <span data-id="element-107">30-Day Money Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}